import React, { useEffect, useState } from "react";
import { Form, Input, Button, message, Card, Spin, Alert } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBullhorn, faFloppyDisk } from "@fortawesome/free-solid-svg-icons";
import productNotesApi from "../../../api/productNotesApi";

// Dòng nhắc hiện trên thẻ sản phẩm ở màn Mua sắm hoàn tiền của từng sàn (app + web).
// Sửa ở đây là app/web đổi ngay — KHÔNG cần OTA app, không cần build lại web.
const PLATFORMS = [
    { key: "shopee", label: "Shopee" },
    { key: "lazada", label: "Lazada" },
    { key: "shopeefood", label: "ShopeeFood" },
    { key: "tiktok", label: "TikTok Shop" },
];

const PLACEHOLDER = "🔥 Thưởng thêm tối đa lên đến 15% điểm hoàn tiền, mua ngay để nhận ưu đãi!";

function ProductNotes() {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        (async () => {
            try {
                const res = await productNotesApi.getConfig();
                const cfg = res.data?.data || {};
                const values = {};
                // Rỗng là giá trị HỢP LỆ (tắt dòng nhắc) → ?? chứ không phải ||
                PLATFORMS.forEach((p) => {
                    values[p.key] = cfg[p.key] ?? "";
                });
                form.setFieldsValue(values);
            } catch {
                message.error("Không tải được cấu hình");
            } finally {
                setLoading(false);
            }
        })();
    }, [form]);

    const onFinish = async (values) => {
        setSaving(true);
        try {
            const payload = {};
            PLATFORMS.forEach((p) => {
                payload[p.key] = (values[p.key] ?? "").trim();
            });
            await productNotesApi.updateConfig(payload);
            message.success("Đã lưu dòng nhắc");
        } catch (err) {
            message.error(err?.response?.data?.message || "Lưu thất bại");
        } finally {
            setSaving(false);
        }
    };

    if (loading) {
        return (
            <div className="p-8 text-center">
                <Spin />
            </div>
        );
    }

    return (
        <div className="p-6 max-w-3xl">
            <div className="flex items-center gap-2 mb-1">
                <FontAwesomeIcon icon={faBullhorn} className="text-amber-600" />
                <h2 className="text-xl font-bold m-0">Dòng nhắc thẻ sản phẩm</h2>
            </div>
            <p className="text-content-3 mb-4">
                Chữ hiện dưới dòng "Hoàn tiền đến" trên thẻ sản phẩm của từng sàn (app + web).
                Sửa xong bấm Lưu là đổi ngay, không cần cập nhật app.
            </p>

            <Alert
                type="info"
                showIcon
                className="mb-4"
                message="Để trống = không hiện gì cho sàn đó"
                description="Dòng này LUÔN hiện với mọi sản phẩm của sàn. Riêng TikTok còn có dòng nhắc 'sàn đang thưởng thêm' ở trang Mua sắm TikTok — dòng đó chỉ hiện với sản phẩm thực sự đang được thưởng thêm."
            />

            <Form form={form} layout="vertical" onFinish={onFinish}>
                <Card size="small" className="mb-4" title="Nội dung theo sàn">
                    {PLATFORMS.map((p, idx) => (
                        <Form.Item
                            key={p.key}
                            name={p.key}
                            label={p.label}
                            rules={[{ max: 300, message: "Tối đa 300 ký tự" }]}
                            className={idx === PLATFORMS.length - 1 ? "mb-0" : ""}
                        >
                            <Input.TextArea rows={2} allowClear placeholder={PLACEHOLDER} />
                        </Form.Item>
                    ))}
                </Card>

                <Button
                    type="primary"
                    htmlType="submit"
                    loading={saving}
                    icon={<FontAwesomeIcon icon={faFloppyDisk} className="mr-2" />}
                >
                    Lưu dòng nhắc
                </Button>
            </Form>
        </div>
    );
}

export default ProductNotes;
